
import { Component } from 'vue-property-decorator';
import Footer from '../components/Footer.vue'
import AbpBase from '../lib/abpbase'
import Ajax from '../lib/ajax'
@Component({
    components: { Footer },    
})
export default class Login extends AbpBase {
    name: string = 'login';
    loading: boolean = false;  
    valid: boolean = false;  
    passwordType: string = 'password';  
    passwordIcon: string = 'mdi-eye-off';  
    backgroundUrl: string = '/static/login-background.jpg';
    logos: any[] = [];
    loginModel = {
        username:'',
        password:'',
        remember_me:false
    }
    async login() {
        if ((this.$refs.loginform as any).validate()) {
            this.loading = true;

            let result = await this.$store.dispatch({
                type: 'app/login',
                data: this.loginModel
            });

            if (result) {
                sessionStorage.setItem('remember_me', this.loginModel.remember_me ? '1' : '0');
                location.reload();
            }
            this.loading = false;
        }      
    }
    rules = {
        username: [v => !!v || this.L('Usuario') + ' ' + this.L('es obligatorio')],
        password: [v => !!v || this.L('Password') + ' ' + this.L('es obligatorio')]
    }

    toggePassword() {
        this.passwordIcon = (this.passwordIcon == 'mdi-eye-off' ? 'mdi-eye' : 'mdi-eye-off');
        this.passwordType = (this.passwordType == 'password' ? 'text' : 'password');
    }

    get loginStyle() {
        return { backgroundImage: `url("${this.backgroundUrl}")` };
    }

    async loadVisualAssets() {
        try {
            const response = await Ajax.get('/api/login-visual-assets');
            const assets = response.data.result;
            if (assets.background) this.backgroundUrl = assets.background.url;
            this.logos = assets.logos || [];
        } catch (error) {
            this.logos = [];
        }
    }

    created(){
        this.loadVisualAssets();
    } 
}
